import './index.less'

import OldInviteNewBanner from './sections/old-invite-new-banner'
import OldInviteNewSteps from './sections/old-invite-new-steps'
import OldInviteNewFaq from './sections/old-invite-new-faq'

document.addEventListener('DOMContentLoaded', () => {
  // banner
  new OldInviteNewBanner()

  // steps
  new OldInviteNewSteps()

  // faq
  new OldInviteNewFaq()
})
